import { useState, useEffect } from 'react';
import throttle from 'lodash/throttle';
export function useStickyUp(translateY) {
  const [sticky, setSticky] = useState(false);
  const [y, setY] = useState(0);
  const handleNavigation = throttle(() => {
    if (window.scrollY > y) {
      // 'scroll down'
      if (window.scrollY >= translateY) {
        setSticky(false);
      } else {
        setSticky(true);
      }
    }
    if (window.scrollY < y) {
      // 'scroll up'
      if (window.scrollY <= translateY) {
        setSticky(false);
      } else {
        setSticky(true);
      }
    }
    setY(window.scrollY);
  }, 100);
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const mainNavElem = document.querySelector('.corp-main-nav');
    if (mainNavElem) {
      window.addEventListener('scroll', handleNavigation);
      return () => {
        window.removeEventListener('scroll', handleNavigation);
      };
    }
  }, [handleNavigation, translateY]);
  return sticky;
}